import React, { useEffect, useState } from 'react';
import ImageGallery from 'react-image-gallery';

import { useLazyGetDownloadURL } from '../../../redux/api/fireBaseStorageApi';
import { IAppFile } from '../../../types/interfaces/app-file';
import { INewFile } from '../../../types/interfaces/new-file';

type IFile = IAppFile | INewFile;

interface IAppImageGalleryProps {
  files: IFile[];
}

export default function AppImageGalery({ files }: IAppImageGalleryProps) {
  const [getFileUrl] = useLazyGetDownloadURL();
  const [images, setImages] = useState<Array<{ original: string }>>([]);

  useEffect(() => {
    Promise.all(
      files.map((file) => {
        if ('fileBlob' in file) {
          return Promise.resolve(file.fileBlob);
        }
        const link = file.storageLink;
        if (!link) {
          return Promise.resolve(null);
        }
        return getFileUrl(
          {
            storageLink: link,
            directLink: file.directStorageLink,
          },
          true,
        )
          .unwrap()
          .catch(() => null);
      }),
    ).then((values) => {
      setImages(
        values
          .filter((v): v is string => Boolean(v))
          .map((v) => ({ original: v })),
      );
    });
  }, [files]);

  return (
    <ImageGallery
      items={images}
      lazyLoad={true}
      showPlayButton={false}
      showFullscreenButton={false}
      disableSwipe={false}
      preventDefaultTouchmoveEvent={false}
    />
  );
}
